import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Signup() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});   // 👈 new
  const { signup } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErrors({}); // reset

    try {
      await signup({ username, email, password });
      nav('/login');
    } catch (err) {
      if (err?.data) {
        // PocketBase returns { fieldName: { message: "..." } }
        const newErrors = {};
        for (const [field, info] of Object.entries(err.data)) {
          newErrors[field] = info.message;
        }
        setErrors(newErrors);
      } else {
        setErrors({ general: err?.message || "Unknown error" });
      }
    }
  };

  return (
    <div className="page auth">
      <h2>Sign Up</h2>
      <form onSubmit={submit}>
        <div>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            required
          />
          {errors.name && <p className="error">{errors.name}</p>}
        </div>

        <div>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            type="email"
            required
          />
          {errors.email && <p className="error">{errors.email}</p>}
        </div>

        <div>
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            type="password"
            required
          />
          {errors.password && <p className="error">{errors.password}</p>}
        </div>

        <button type="submit">Create account</button>

        {errors.general && <p className="error">{errors.general}</p>}
      </form>

      <p>Already registered? <Link to="/login">Login</Link></p>
    </div>
  );
}
